import React from "react";

interface NavigationMenuProps {
  activeView: string;
  setActiveView: (view: string) => void;
  showLeaderboard?: boolean;
}

export const NavigationMenu = ({ activeView, setActiveView, showLeaderboard = true }: NavigationMenuProps) => (
    <div className="navigation-menu">
      <div
        className={`nav-item ${activeView === 'calendar' ? 'active' : ''}`}
        onClick={() => setActiveView('calendar')}
      >
        Calendar
      </div>
      <div
        className={`nav-item ${activeView === 'locations' ? 'active' : ''}`}
        onClick={() => setActiveView('locations')}
      >
        Locations
      </div>
      {showLeaderboard && (
        <div
          className={`nav-item ${activeView === 'leaderboard' ? 'active' : ''}`}
          onClick={() => setActiveView('leaderboard')}
        >
          Leaderboard
        </div>
      )}
    </div>
  );

